import { render, staticRenderFns } from "./gameMenu.vue?vue&type=template&id=ea5e894e&scoped=true&"
import script from "./gameMenu.vue?vue&type=script&lang=js&"
export * from "./gameMenu.vue?vue&type=script&lang=js&"
import style0 from "./gameMenu.vue?vue&type=style&index=0&id=ea5e894e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5e894e",
  null
  
)

export default component.exports